<template>
    <div class="Sac-Principal">
        <PageTitle icon="fa fa-phone" main="Solicitações"
            sub="Atendimento aos colaboradores" />
        <div class="Sac-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="SAC" active><SacSolicitacao /></b-tab>                                                                                                                                            
                    <b-tab title="Indicadores"><SacSolicitacaoPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import SacSolicitacao from '../sac_solicitacao/SacSolicitacao'
import SacSolicitacaoPainel from '../sac_solicitacao/SacSolicitacaoPainel'
export default {
    name: 'SacPrincipal',    
    components: { PageTitle, SacSolicitacao,SacSolicitacaoPainel}
    
}
</script>

<style>

</style>






